import { Component, OnInit, ViewChild, AfterContentInit, AfterViewInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-supplementaltaxestimator',
    templateUrl: './supplementaltaxestimator.component.html',
    styleUrls: ['./supplementaltaxestimator.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SupplementaltaxestimatorComponent implements OnInit, AfterViewInit {

  id: number;

  constructor(private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id;
  }
  ngAfterViewInit() {

  }

  ngOnInit() {

  }


}
